import type { CarOrderDetailResponse } from "@/api/car";

import { formatPickupReturn } from "../utils";

type CarOrderData = CarOrderDetailResponse["data"];

type Props = {
  data: Pick<CarOrderData, "car" | "insurance" | "pickup" | "return">;
};

export default function CarVehicleCard({ data }: Props) {
  const gearboxText = data.car.gearbox === 1 ? "自动" : "手动";

  return (
    <div className="mx-4 mt-3 bg-white rounded-2xl overflow-hidden">
      <img
        src={data.car.cover || "https://placehold.co/400x175?text=Car"}
        alt=""
        className="w-full object-cover object-center"
        style={{ height: 150 }}
      />
      <div className="p-4">
        <div className="text-base font-bold text-gray-900 mb-1">
          {data.car.title}
        </div>
        <div className="flex flex-wrap items-center gap-3 text-xs text-gray-400 mb-3">
          <span>
            <i className="ri-user-line mr-1" />
            {data.car.seats_text || `${data.car.seats}座`}
          </span>
          <span>
            <i className="ri-settings-2-line mr-1" />
            {gearboxText}
          </span>
          {data.car.displacement ? (
            <span>
              <i className="ri-gas-station-line mr-1" />
              {data.car.displacement}
            </span>
          ) : null}
          <span>
            <i className="ri-shield-check-line mr-1" />
            {data.insurance.type_text}
          </span>
        </div>
        <div
          className="rounded-2xl p-3 space-y-2.5"
          style={{ background: "#F8F8F8" }}
        >
          {[
            [
              "取车时间",
              formatPickupReturn(data.pickup.date, data.pickup.time),
            ],
            ["取车地点", data.pickup.location || "待确认"],
            [
              "还车时间",
              formatPickupReturn(data.return.date, data.return.time),
            ],
            ["还车地点", data.return.location || "待确认"],
          ].map(([l, v]) => (
            <div
              key={String(l)}
              className="flex items-center justify-between text-xs"
            >
              <span className="text-gray-400">{l}</span>
              <span className="text-gray-700 font-medium text-right max-w-[65%]">
                {v}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
